// @ts-nocheck

/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@kubb/plugin-client/clients/axios";
import type { PollLinkStatusAuthLinkTelegramPollGetQueryResponse, PollLinkStatusAuthLinkTelegramPollGetQueryParams, PollLinkStatusAuthLinkTelegramPollGet401, PollLinkStatusAuthLinkTelegramPollGet404, PollLinkStatusAuthLinkTelegramPollGet422 } from "../models/accountLinkingController/PollLinkStatusAuthLinkTelegramPollGet.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@kubb/plugin-client/clients/axios";

function getPollLinkStatusAuthLinkTelegramPollGetUrl() {
  const res = { method: 'GET', url: `/auth/link/telegram/poll` as const }
  return res
}

/**
 * @description Poll link token status.
 * Frontend polls this endpoint to detect when linking completes.
 * Returns status: "pending" | "completed" | "expired"
 * @summary Poll Link Status
 * {@link /auth/link/telegram/poll}
 */
export async function pollLinkStatusAuthLinkTelegramPollGet(params: PollLinkStatusAuthLinkTelegramPollGetQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<PollLinkStatusAuthLinkTelegramPollGetQueryResponse, ResponseErrorConfig<PollLinkStatusAuthLinkTelegramPollGet401 | PollLinkStatusAuthLinkTelegramPollGet404 | PollLinkStatusAuthLinkTelegramPollGet422>, unknown>({ method : "GET", url : getPollLinkStatusAuthLinkTelegramPollGetUrl().url.toString(), params, ... requestConfig })
  return res.data
}